import Icon from 'components/shared/Icon'

type ErrorProps = {
  title?: string
}

const Error = ({ title = 'Error occurred' }: ErrorProps) => (
  <div className='pv12 lite-grey flex flex-column items-center f3'>
    <span className='w7'><Icon name='icon-alert' className='w7' /></span>
    <span className='mt6'>
      {title}
    </span>
    <script type='text/javascript'>
      self.location=self.location
    </script>
  </div>
)

export default Error
